import { DecimalPipe } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

/**
 * Social proof component
 */
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-social-proof',
	imports: [DecimalPipe, TranslatePipe],
	templateUrl: './social-proof.html',
})
export class SocialProofComponent extends BaseDirective {
	numberOfRatings = input(0);
	alignment = input<'left' | 'right'>('left');
	size = input<'sm' | 'base' | 'lg'>('base');
	showGradeBackGround = input(true);
	rating = input(8);
	showOnlyText = input(false);

	ratingText = computed(() => {
		const score = this.rating() * 10;

		if (score >= 88) {
			return 'amazing';
		} else if (score >= 84) {
			return 'fantastic';
		}
		return 'great';
	});

	constructor() {
		super();
	}
}
